import Router from './routes';
import './App.css';
import Header from './components/Header';

function App() {
  return (
    <>
      <Header />
      <Router />
    </>
  );
}

export default App;
